import Product from "../Components/product/product-main/Product.tsx";

const ProductDetails = () => {
  return <Product />;
};

export default ProductDetails;
